<template>
  <el-dropdown class="lang-switch" @command="switchLang">
  <span class="el-dropdown-link">
    {{lang}}
    <img class="pre" src="@/assets/images/head/select_nor.png" alt="">
    <img class="hot" src="@/assets/images/head/select_hot.png" alt="">
  </span>
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item command="zh">中文</el-dropdown-item>
    <el-dropdown-item command="en">English</el-dropdown-item>
  </el-dropdown-menu>
  <img v-if="lang === 'English'" class="language-image" src="@/assets/images/head/english.png" alt="">
  <img v-else class="language-image" src="@/assets/images/head/chinese.png" alt="">
</el-dropdown>
</template>
<script>
import ZlgCloudHelper from '@/native/zlgcloudhelper.js'
import {mapMutations} from 'vuex'
export default {
  data () {
    return {
      lang: '中文',
      username: JSON.parse(localStorage.getItem('zlg_label_userinfo')).username
    }
  },
  created () {
    this.switchLang(JSON.parse(localStorage.getItem('zlg_label_userinfo')).language || 'zh')
  },
  methods: {
    ...mapMutations(['SET_LANGUAGE']),
    switchLang (command, trigger) {
      let language = ''
      switch (command) {
        case 'en':
          language = 'English'
          break
        case 'zh':
          language = '中文'
          break
      }
      this.lang = language
      this.$i18n.locale = command
      this.SET_LANGUAGE(command)
      if (trigger) {
        ZlgCloudHelper.updateUserInfor({
          username: this.username,
          info: {language: command}
        }).then(res => {
          localStorage.setItem('zlg_label_userinfo', JSON.stringify(res.data))
          localStorage.setItem('zlb_label_language', command)
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.lang-switch {
  color: #eaebed;
  display: inline-block;
  font-size: 14px;
  position: relative;
  .el-dropdown-link {
    img {
      margin-left: 6px;
    }
    .hot {
      display: none;
    }
    &:hover {
      .hot {
        display: inline-block;
      }
      .pre {
        display: none;
      }
    }
  }
  .language-image {
    position: absolute;
    top: 50%;
    left: -32px;
    transform: translateY(-50%);
    -moz-transform: translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/Auth/Language.vue